

















import { defineComponent, type PropType } from "vue-demi";
import type { UserCartItem } from "../../../type/UserCart";

export default defineComponent({
  name: "CartTool",
  props: {
    item: {
      type: Object as PropType<UserCartItem | null>,
      default: null,
    },
    small: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: {
    add: (_: number) => true,
    remove: (_: number) => true,
  },
  methods: {
    handleClickCart() {
      if (this.item) {
        this.$emit("remove", 1);
      } else {
        this.$emit("add", 1);
      }
    },
  },
});
